import { useEffect } from "react";
import { toast } from "sonner";

import { applyUpdate, SW_UPDATE_EVENT, type SwUpdateDetail } from "@/pwa/register";

/**
 * Listens for a waiting service-worker update and shows a non-intrusive toast.
 * Updating is always user-initiated — CatalogKit never reloads mid-session on
 * its own. Renders nothing.
 */
export function PWAUpdater(): null {
  useEffect(() => {
    function onUpdate(event: Event): void {
      const { worker } = (event as CustomEvent<SwUpdateDetail>).detail;
      toast("A new version of CatalogKit is available.", {
        duration: Infinity,
        action: { label: "Update now", onClick: () => applyUpdate(worker) },
        cancel: { label: "Later", onClick: () => undefined },
      });
    }
    window.addEventListener(SW_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(SW_UPDATE_EVENT, onUpdate);
  }, []);

  return null;
}
